import React from 'react';
import { SortField, SortOrder } from '../../types/Campaign';

interface ListHeaderProps {
  sortField: SortField;
  sortOrder: SortOrder;
  onSort: (field: SortField) => void;
}

const headerLabels: Record<SortField, string> = {
  campaignTitle: 'Campanha',
  brandName: 'Marca',
  startDate: 'Início',
  endDate: 'Fim',
};

export const ListHeader: React.FC<ListHeaderProps> = ({ sortField, sortOrder, onSort }) => {
  const SortButton: React.FC<{ field: SortField; label: string; align?: string }> = ({
    field,
    label,
    align = 'center',
  }) => {
    const isActive = sortField === field;
    const justifyClass = align === 'left' ? 'justify-start' : 'justify-center';
    return (
      <button
        onClick={() => onSort(field)}
        className={`text-xs font-semibold text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 flex items-center gap-1.5 transition-colors ${justifyClass}`}
      >
        {label}
        {isActive && <span className="text-gray-900 dark:text-gray-100">{sortOrder === 'asc' ? '↑' : '↓'}</span>}
      </button>
    );
  };

  return (
    <div className="hidden lg:block bg-white/80 dark:bg-dark-300/80 backdrop-blur-sm rounded-3xl p-6 mb-3 border-0 shadow-soft">
      <div className="grid grid-cols-[90px_1fr_110px_110px_220px_110px_90px_110px] gap-6 items-center">
        <div className="text-center">
          <span className="text-xs font-semibold text-gray-600 dark:text-gray-400">Status</span>
        </div>

        <div>
          <SortButton field="campaignTitle" label={headerLabels.campaignTitle} align="left" />
        </div>

        <div>
          <SortButton field="startDate" label={headerLabels.startDate} align="left" />
        </div>

        <div>
          <SortButton field="endDate" label={headerLabels.endDate} align="left" />
        </div>

        <div className="text-left">
          <span className="text-xs font-semibold text-gray-600 dark:text-gray-400">Orçamento</span>
        </div>

        <div className="text-center">
          <span className="text-xs font-semibold text-gray-600 dark:text-gray-400">Criadores</span>
        </div>

        <div className="text-center">
          <span className="text-xs font-semibold text-gray-600 dark:text-gray-400">Conteúdos</span>
        </div>

        <div className="text-center">
          <span className="text-xs font-semibold text-gray-600 dark:text-gray-400">Rejeitados</span>
        </div>
      </div>
    </div>
  );
};
